import React, { useState, useContext, useEffect } from 'react';
import { GlobalContext } from '../../providers/GlobalProvider';
import DatahubAPI from '../../api/DatahubAPI';
import DataSearchAPI from '../../api/DataSearch';
import Stepper from 'components/Automation/UIStepper/Stepper';
import { Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import SupplierQuestionnaire from 'components/Automation/UIStepper/SupplierStepper';
import { tempInfo } from 'components/Automation/TemplateInfo';
import { convertBase64ToFile } from 'utils/fileHelper';
import { fileHandler, mapRowData } from 'utils/excelRenderer';
import PaymentsAPI from 'api/PaymentsAPI';
import SubscribeModal from 'components/SubscribeModal';
import { Typography } from '@mui/material';
import { Player } from '@lottiefiles/react-lottie-player';

const AutomationBuilder: React.FC = (props: any) => {
  const history = useHistory();
  if (!props.location.state) {
    history.push('/bite-monitor');
    return <></>;
  }


  const { name, cur_case } = props?.location?.state;
  const { cur_user } = useContext(GlobalContext);

  const [ autoName, setAutoName ] = useState('New Ticket');
  const [ type, setType ] = useState('');
  const [ template, setTemplate ] = useState([ '' ]);
  const [ file, setFile ] = useState<any>(undefined);
  const [ rows, setRows ] = useState([]);
  const [ cols, setCols ] = useState<string[]>([]);
  const [ frequency, setFrequency ] = useState('Once');
  const [ shareWith, setShareWith ] = useState([]);
  const [ selectedSourceBox, setSelectedSourceBox ] = useState<number>(5);
  const [ colsArr, setColsArr ] = useState<any>([]);
  const [ screeningCus, setScreeningCus ] = useState({ isLoading: true, data: '' });
  const [ userHasMonitor, setUserHasMonitor ] = useState(false);
  const [ activeSub, setActiveSub ] = useState(false);
  const [ matchedTeamWithStripe, setMatchedTeamWithStripe ] =
    useState<string>('');
  const [ entFilters, setEntFilters ] = useState<any>({
    isLoaded: false,
    arr: [],
  });
  const [ comFilters, setComFilters ] = useState<any>({
    isLoaded: false,
    arr: [],
  });
  const [ entityState, setEntityState ] = useState({
    fuzzy: false,
    date: null,
    dateRange: [],
    lenses: [],
    countries: [],
    agencies: [],
    lists: [],
  });

  const [ commodityState, setCommodityState ] = useState({
    fuzzy: false,
    date: null,
    dateRange: [],
    comLenses: [],
    countries: [],
    agencies: [],
    lists: [],
  });
  useEffect(() => {
    checkForMonitor();
  }, []);

  const checkForMonitor = () => {
    if (
      cur_user.selected_team?.attributes?.tier?.includes('enterprise') ||
      cur_user.selected_team?.attributes?.tier?.includes('standard') ||
      cur_user.selected_team?.attributes?.tier?.includes('pro')
    ) {
      setUserHasMonitor(true);
    }
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setMatchedTeamWithStripe(cus.id);
          cus.subscriptions.data.map((sub: any) => {
            if (
              sub.metadata.moduleName === 'BITE Pro' ||
              sub.metadata.moduleName === 'BITE Enterprise'
            ) {
              setActiveSub(true);
            }
          });
        }
      });
    }
  };

  const getFilters = async() => {
    const mongoReq = {
      query: {
        groupId: cur_user?.selected_team?.id,
        userId: cur_user?.basics?.id,
      },
    };
    const res = await DataSearchAPI.getUserSearchFilters(mongoReq);
    if (res?.success) {
      const entArr: any = [];
      const comArr: any = [];

      res.result.forEach((filt: any) => {
        if (filt.type === 'entity') {
          entArr.push(filt);
        } else {
          comArr.push(filt);
        }
      });

      setEntFilters({ isLoaded: true, arr: entArr });
      setComFilters({ isLoaded: true, arr: comArr });
    }
  };

  const getTemp = (str: string) => {
    const foundTemp = tempInfo.find((obj: any) => obj.title === str);
    if (foundTemp) {
      return foundTemp?.headers;
    }
    return [ '' ];
  };

  const handleFile = async() => {
    const fileType = convertBase64ToFile(cur_case.documents[0].uploadedFile.base64, cur_case.documents[0].uploadedFile.name);

    setFile(fileType);
    const { rows } = await fileHandler(fileType);
    const colNames: string[] = rows[0];


    const rowData = rows.slice(1);
    const mappedRowData = mapRowData(colNames, rowData);
    setRows(mappedRowData);
    setCols(colNames);
    if (cur_case.docType === 'Bulk Screening' && (cur_case.colMapping?.length === 0 || !cur_case.colMapping)) {
      if (!cur_case.template || cur_case.template?.length === 0) {
        setTemplate(colNames);
      }
      const colsArrofObjs: any[] = [];
      colNames.forEach((col: any) => {
        const obj = {
          prop: 'bulk',
          val: col,
        };
        colsArrofObjs.push(obj);
      });
      setColsArr(colsArrofObjs);
    }
  };

  const getCusFromEmail = async() => {
    const res = await PaymentsAPI.getCustomerByEmail(
      cur_user.selected_team.attributes.team_admin[0]
    );
    if (res?.success) {
      res?.result?.data?.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setScreeningCus({ isLoading: false, data: cus });
        }
      });
    }
  };


  useEffect(() => {
    getCusFromEmail();
    getFilters();
    if (cur_case) {
      setAutoName(cur_case.ticketName);
      setFrequency(cur_case.frequency);
      setShareWith(cur_case.sharedWith);

      setSelectedSourceBox(cur_case.docType.includes('Single Entry') ? 5 : cur_case.docType === 'Supplier Questionnaire' ? 4 : 1);
      setType(cur_case.docType);
      if (cur_case.template.length > 0) {
        setTemplate(cur_case.template);
      } else {
        const temp = getTemp(cur_case.docType);
        setTemplate(temp);
      }
      if (cur_case.colMapping?.length > 0) {
        setColsArr(cur_case.colMapping);
      }
      const entObj = {
        lenses: cur_case.entityFilter.lenses,
        countries: cur_case.entityFilter.countries,
        agencies: cur_case.entityFilter.agencies,
        lists: cur_case.entityFilter.lists,
        fuzzy: cur_case.entityFilter.entRes,
        dateRange: cur_case.entityFilter.filterDate,
        date: null
      };
      setEntityState(entObj);

      const comObj = {
        comLenses: cur_case.commodityFilter.lenses,
        countries: cur_case.commodityFilter.countries,
        agencies: cur_case.commodityFilter.agencies,
        lists: cur_case.commodityFilter.lists,
        fuzzy: cur_case.commodityFilter.entRes,
        dateRange: cur_case.commodityFilter.filterDate,
        date: null
      };

      setCommodityState(comObj);

      if (cur_case.documents.length > 0) {
        handleFile();
      }
    } else {
      setType(name);
      if (name === 'Supplier Questionnaire') {
        setSelectedSourceBox(4);
      }
      if (name === 'Multiple Entries') {
        setSelectedSourceBox(1);
      }
      const temp = getTemp(name);
      setTemplate(temp);
    }
  }, []);

  return (

    <section className='home-content-body Home-HeaderDown' style={{ minHeight: 0 }} >
      {activeSub && !userHasMonitor ? (
        <div className='no-license-modal'>
          <Player
            autoplay
            loop
            src='https://lottie.host/3c23c1ad-7f71-4e3d-8f19-69154715dbdc/SdWWjCmU1J.json'
            style={{ width: '20%' }}
          ></Player>
          <Typography
            variant='h6'
            className='text-white'
            style={{
              fontSize: '20px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px',
            }}
          >
            You need an assigned license to access this module
          </Typography>
          <Typography
            variant='h6'
            style={{
              fontSize: '18px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px',
              marginTop: '20px',
              color: '#BDBEC1',
            }}
          >
            Visit Account &gt; Users &gt; to assign an available license to your
            user or contact your team admin
          </Typography>
        </div>
      ) : !userHasMonitor ? (
        <SubscribeModal
          name='BITE Monitor'
          description='Keep track of all risk reports, investigative analysis and trend reports'
          price={25}
          curUser={cur_user}
          stripeTeam={matchedTeamWithStripe}
          activeSub={activeSub}
          screening={true}
        />
      ) : (
        <></>
      )}
      <Grid container>
        <Grid item xs={12}>
          {selectedSourceBox === 4 ? (
            <>
              <SupplierQuestionnaire
                autoName={autoName}
                setAutoName={setAutoName}
                type={type}
                setType={setType}
                template={template}
                setTemplate={setTemplate}
                file={file}
                setFile={setFile}
                rows={rows}
                setRows={setRows}
                cols={cols}
                setCols={setCols}
                frequency={frequency}
                shareWith={shareWith}
                setShareWith={setShareWith}
                setFrequency={setFrequency}
                entFilters={entFilters}
                setEntFilters={setEntFilters}
                comFilters={comFilters}
                setComFilters={setComFilters}
                entityState={entityState}
                setEntityState={setEntityState}
                commodityState={commodityState}
                setCommodityState={setCommodityState}
                selectedSourceBox={selectedSourceBox}
                setSelectedSourceBox={setSelectedSourceBox}
                cur_case={cur_case}
                screeningCus={screeningCus}
                userHasMonitor={userHasMonitor}
              />
            </>
          ) : (
            <Stepper
              autoName={autoName}
              setAutoName={setAutoName}
              type={type}
              setType={setType}
              template={template}
              setTemplate={setTemplate}
              file={file}
              setFile={setFile}
              rows={rows}
              setRows={setRows}
              cols={cols}
              setCols={setCols}
              frequency={frequency}
              shareWith={shareWith}
              setShareWith={setShareWith}
              setFrequency={setFrequency}
              entFilters={entFilters}
              setEntFilters={setEntFilters}
              comFilters={comFilters}
              setComFilters={setComFilters}
              entityState={entityState}
              setEntityState={setEntityState}
              commodityState={commodityState}
              setCommodityState={setCommodityState}
              selectedSourceBox={selectedSourceBox}
              setSelectedSourceBox={setSelectedSourceBox}
              cur_case={cur_case}
              colsArr={colsArr}
              setColsArr={setColsArr}
              screeningCus={screeningCus}
              userHasMonitor={userHasMonitor}
            />
          )}
        </Grid>
      </Grid>
    </section>
  );
};

export default AutomationBuilder;
